import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { Header } from '../components/Header';
import { CheckoutSteps } from '../components/CheckoutSteps';
import { ShippingForm } from '../components/ShippingForm';
import { PaymentForm } from '../components/PaymentForm';
import { OrderSummary } from '../components/OrderSummary';
import { OrderConfirmation } from '../components/OrderConfirmation';
export const CheckoutPage: React.FC = () => {
  const {
    items,
    totalPrice,
    totalItems
  } = useCart();
  const [currentStep, setCurrentStep] = useState(1);
  const [orderComplete, setOrderComplete] = useState(false);
  const [shippingInfo, setShippingInfo] = useState({
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    country: 'United States',
    phone: ''
  });
  const [paymentInfo, setPaymentInfo] = useState({
    cardNumber: '',
    nameOnCard: '',
    expiryDate: '',
    cvv: ''
  });
  const handleShippingSubmit = (data: typeof shippingInfo) => {
    setShippingInfo(data);
    setCurrentStep(2);
    window.scrollTo(0, 0);
  };
  const handlePaymentSubmit = (data: typeof paymentInfo) => {
    setPaymentInfo(data);
    setCurrentStep(3);
    window.scrollTo(0, 0);
  };
  const handlePlaceOrder = () => {
    setOrderComplete(true);
    setCurrentStep(4);
    window.scrollTo(0, 0);
  };
  if (items.length === 0 && !orderComplete) {
    return <div className="min-h-screen bg-gray-50" data-id="element-338">
        <Header data-id="element-339" />
        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8" data-id="element-340">
          <div className="max-w-xl mx-auto text-center" data-id="element-341">
            <h1 className="text-3xl font-extrabold text-gray-900" data-id="element-342">
              Your cart is empty
            </h1>
            <p className="mt-4 text-gray-500" data-id="element-343">
              Add some items to your cart before proceeding to checkout.
            </p>
            <div className="mt-6" data-id="element-344">
              <a href="/" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-fuchsia-600 hover:bg-fuchsia-700" data-id="element-345">
                Continue Shopping
              </a>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50" data-id="element-346">
      <Header data-id="element-347" />
      <main className="max-w-7xl mx-auto pt-8 pb-24 px-4 sm:px-6 lg:px-8" data-id="element-348">
        <div className="max-w-2xl mx-auto lg:max-w-none" data-id="element-349">
          <h1 className="text-3xl font-extrabold text-gray-900 text-center mb-8" data-id="element-350">
            {currentStep === 4 ? 'Order Confirmation' : 'Checkout'}
          </h1>
          <CheckoutSteps currentStep={currentStep} data-id="element-351" />
          <div className="mt-12 lg:grid lg:grid-cols-12 lg:gap-x-12 lg:items-start xl:gap-x-16" data-id="element-352">
            <div className="lg:col-span-7" data-id="element-353">
              {currentStep === 1 && <ShippingForm initialValues={shippingInfo} onSubmit={handleShippingSubmit} data-id="element-354" />}
              {currentStep === 2 && <PaymentForm initialValues={paymentInfo} onSubmit={handlePaymentSubmit} onBack={() => setCurrentStep(1)} data-id="element-355" />}
              {currentStep === 3 && <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6" data-id="element-356">
                  <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-357">
                    Review and Place Order
                  </h2>
                  <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-358">
                    <h3 className="text-base font-medium text-gray-900 mb-2" data-id="element-359">
                      Shipping Information
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-360">
                      {shippingInfo.firstName} {shippingInfo.lastName}
                      <br data-id="element-361" />
                      {shippingInfo.address}
                      <br data-id="element-362" />
                      {shippingInfo.city}, {shippingInfo.state}{' '}
                      {shippingInfo.zipCode}
                      <br data-id="element-363" />
                      {shippingInfo.country}
                      <br data-id="element-364" />
                      {shippingInfo.phone}
                    </p>
                  </div>
                  <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-365">
                    <h3 className="text-base font-medium text-gray-900 mb-2" data-id="element-366">
                      Payment Method
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-367">
                      Credit Card ending in {paymentInfo.cardNumber.slice(-4)}
                      <br data-id="element-368" />
                      {paymentInfo.nameOnCard}
                    </p>
                  </div>
                  <div className="mt-8 flex justify-between space-x-4" data-id="element-369">
                    <button type="button" className="py-2 px-4 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-500" onClick={() => setCurrentStep(2)} data-id="element-370">
                      Back to Payment
                    </button>
                    <button type="button" className="py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-fuchsia-600 hover:bg-fuchsia-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-500" onClick={handlePlaceOrder} data-id="element-371">
                      Place Order
                    </button>
                  </div>
                </div>}
              {currentStep === 4 && <OrderConfirmation orderNumber={`ORD-${Math.floor(100000 + Math.random() * 900000)}`} shippingInfo={shippingInfo} data-id="element-372" />}
            </div>
            <div className="mt-10 lg:mt-0 lg:col-span-5" data-id="element-373">
              {currentStep < 4 ? <OrderSummary items={items} totalPrice={totalPrice} totalItems={totalItems} data-id="element-374" /> : <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6" data-id="element-375">
                  <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-376">
                    Order Details
                  </h2>
                  <div className="border-t border-gray-200 pt-4" data-id="element-377">
                    <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-378">
                      <p data-id="element-379">Order number:</p>
                      <p className="font-medium text-gray-900" data-id="element-380">
                        {`ORD-${Math.floor(100000 + Math.random() * 900000)}`}
                      </p>
                    </div>
                    <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-381">
                      <p data-id="element-382">Date:</p>
                      <p className="font-medium text-gray-900" data-id="element-383">
                        {new Date().toLocaleDateString()}
                      </p>
                    </div>
                    <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-384">
                      <p data-id="element-385">Total:</p>
                      <p className="font-medium text-gray-900" data-id="element-386">
                        ${(totalPrice + totalPrice * 0.07).toFixed(2)}
                      </p>
                    </div>
                    <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-387">
                      <p data-id="element-388">Payment method:</p>
                      <p className="font-medium text-gray-900" data-id="element-389">
                        •••• {paymentInfo.cardNumber.slice(-4)}
                      </p>
                    </div>
                  </div>
                  <div className="mt-6 border-t border-gray-200 pt-4" data-id="element-390">
                    <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-391">
                      Estimated Delivery
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-392">
                      {new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString()}{' '}
                      -{' '}
                      {new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toLocaleDateString()}
                    </p>
                  </div>
                  <div className="mt-6" data-id="element-393">
                    <a href="/" className="inline-flex w-full justify-center items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-fuchsia-600 hover:bg-fuchsia-700" data-id="element-394">
                      Track Order
                    </a>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </main>
    </div>;
};